module.exports = __webpack_public_path__ + "img/nav-design-fancy.5899e7d.jpg";